module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "map-container"
    }
  }, [_c('div', {
    ref: "map",
    style: ({
      'pointer-events': _vm.tool === 'Map' ? 'all' : 'none'
    }),
    attrs: {
      "id": "map"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tool === 'Map'),
      expression: "tool === 'Map'"
    }],
    attrs: {
      "id": "autocomplete"
    }
  }, [_c('span', {
    staticClass: "input-text"
  }, [_c('input', {
    ref: "addressSearch",
    attrs: {
      "type": "text",
      "placeholder": "Search for a location"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tool === 'Map'),
      expression: "tool === 'Map'"
    }],
    attrs: {
      "id": "help-text"
    }
  }, [_c('p', [_vm._v("Drag the map and/or search to set desired location.  Use alt+shift to rotate the north axis. Click 'Done' when finished.")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.finishSetup
    }
  }, [_vm._v("Done")])]), _vm._v(" "), (_vm.mapModalVisible && !_vm.mapInitialized) ? _c('map-modal', {
    on: {
      "close": function($event) {
        _vm.mapModalVisible = false;
        _vm.showReticle()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "reticle"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3d99eee3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Canvas/Map.vue
// module id = 674
// module chunks = 2